import React from 'react';

const Footer = () => (
  <footer className="text-center py-4 bg-dark text-white mt-auto">
    <div className="container">
      <p className="mb-0">&copy; 2025 PortaForge. Built for developers, by developers.</p>
    </div>
  </footer>
);

export default Footer;
